import { ReactNode } from "react"

import { cn } from "@/domains/library"

export interface VerticalTableRow {
  label: ReactNode
  value: ReactNode
}

export interface VerticalTableProps {
  rows: VerticalTableRow[]
  className?: string
}

/**
 * Vertical table component with full-width horizontal separators between rows.
 * No background - designed to be full-width within its container.
 * Uses similar separator styling to the footer component.
 */
export function VerticalTable({ rows, className }: VerticalTableProps) {
  return (
    <div className={cn("w-full", className)}>
      {rows.map((row, index) => (
        <div key={index}>
          <div className="flex w-full items-center justify-between py-4">
            <div className="text-left font-semibold text-t100">{row.label}</div>
            <div className="text-right text-t100">{row.value}</div>
          </div>
          {index < rows.length - 1 && (
            <div className="border-b-[0.5px] border-white/20 w-full" />
          )}
        </div>
      ))}
    </div>
  )
}
